<template>
  <div id="SearchCatering" v-bind="loading()" class="container">
    <div class="row">
      <div class="col s12 m12 l12 xl12">
        <div class="card border_card">
          <div class="card-image img-movil">
            <img src="../assets/logo.png">
          </div>
          <div class="card-content text-content">
            <span class="card-title red-text text-darken-4 text-content center">Servicio & Bienestar</span>
            <p class>
              Servicio de Alimentación. Menús exquisitos y variados que llevaran a tu paladar
              a recorrer la gastronomía nacional e internacional.
              <br>
              <br>
            </p>
            <form class="s12 m12 xl12" @submit.prevent="sendMail">
              <div class="row">
                <div class="input-field col s12 m12 xl12">
                  <i class="material-icons prefix">public</i>
                  <select
                    id="city"
                    v-model="form.city"
                    @change="onChange($event)"
                    class="validate icons"
                    required
                  >
                    <option value disabled selected>Elige tu Ciudad</option>
                    <option
                      v-for="(Obj, key) in ObjCities"
                      v-bind:value="key"
                      v-bind:data-icon="Obj.src"
                      v-bind:key="key"
                    >{{Obj.city}}</option>
                  </select>
                  <label for="city">Elige tu ciudad.</label>
                  <span
                    class="helper-text"
                    data-error="Seleccione una Ciudad Valido"
                    data-success="Ciudad OK!"
                  ></span>
                </div>

                <div class="input-field col s12 m12 xl12">
                  <i class="material-icons prefix">restaurant</i>
                  <select
                    id="catering"
                    v-model="form.catering"
                    class="validate icons select-jx"
                    required
                  >
                    <option value disabled selected>Elige tu Catering</option>
                    <option
                      v-for="(Item, key) in ObjCatering"
                      v-bind:value="Item.code"
                      v-bind:key="key"
                    >{{Item.name}}</option>
                  </select>
                  <label for="catering">Elige un Catering.</label>
                  <span
                    class="helper-text"
                    data-error="Seleccione un Catering Valido"
                    data-success="Catering OK!"
                  ></span>
                </div>
                <div class="input-field s12 m12 xl12 center">
                  <router-link
                    v-bind:to="{name:'InfoCatering',params:{'cateringId':form.catering}}"
                    class="btn-small waves-effect waves-light red darken-4"
                  >
                    Ver Catering
                    <i class="material-icons left">restaurant</i>
                  </router-link>

                  <router-link
                    v-bind:to="{name:'RegisterUser'}"
                    class="btn-small waves-effect waves-light grey lighten-1 red-text text-darken-4"
                  >Registrarse</router-link>
                </div>
                <br>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "InfoCatering",
  data() {
    return {
      cateringId: String,
      form: {
        city: String,
        catering: null
      },
      ObjCatering: [
        {
          code: "000",
          name: "Catering"
        }
      ],
      ObjCities: [
        {
          code: "001",
          city: "Bogotá",
          src: require("../assets/flag/100px-Flag_of_Bogota.svg.png"),
          catering: [
            {
              code: "001",
              name: "Bogota-001"
            },
            {
              code: "010",
              name: "Bogota-010"
            }
          ]
        },
        {
          code: "1",
          city: "Medellín",
          src: require("../assets/flag/Flag_of_Medellin.svg.png"),
          catering: [
            {
              code: "002",
              name: "Medallo-001"
            }
          ]
        },
        {
          code: "2",
          city: "Barranquilla",
          src: require("../assets/flag/100px-Flag_of_Barranquilla.svg.png"),
          catering: [
            {
              code: "003",
              name: "Quilla-001"
            }
          ]
        },
        {
          code: "3",
          city: "Cúcuta",
          src: require("../assets/flag/100px-Flag_of_Cucuta.svg.png"),
          catering: [
            {
              code: "004",
              name: "Cucu-001"
            }
          ]
        },
        {
          code: "4",
          city: "Santa Marta",
          src: require("../assets/flag/100px-Flag_of_Santa_Marta.svg.png"),
          catering: [
            {
              code: "005",
              name: "Santa-001"
            }
          ]
        },
        {
          code: "5",
          city: "Valledupar",
          src: require("../assets/flag/100px-Flag_of_Valledupar.svg.png"),
          catering: [
            {
              code: "006",
              name: "Valle-001"
            }
          ]
        },
        {
          code: "6",
          city: "Buenaventura",
          src: require("../assets/flag/Flag_of_Buenaventura.svg.png"),
          catering: [
            {
              code: "007",
              name: "Buena-001"
            }
          ]
        }
      ]
    };
  },
  methods: {
    sendMail() {
      console.log("Envio");
    },
    onChange(event) {
      var city_id = event.srcElement.value;
      this.ObjCatering = this.ObjCities[city_id].catering;
      this.form.catering = this.ObjCatering[0].code;
      //this.cateringId = this.form.catering.code
      //console.log("onChange");
    },
    loading() {
      $(document).ready(function() {
        $(".sidenav").sidenav(); //Act el menu
        $("select").formSelect(); //Form Select
      });
    }
  }
};
</script>

<style scoped lang="css">
.container {
  width: 95% !important;
}
.row {
  margin-bottom: 0px !important;
}
.row .col {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0 0 0 0 !important;
  min-height: 1px;
}

#SearchCatering {
  padding-top: 50px;
}
.card .card-content{
  padding-top: 100px !important;
}
.card .img-movil img {
  width: 192px !important;
  position: absolute;
  top: -100px;
  left: 25%;
  left: calc(50% - 100px);
}
.border_card {
  border-radius: 20px !important;
}
.input-field {
  margin-top: 0.5rem !important;
  margin-bottom: 0rem !important;
}
</style>



// WEBPACK FOOTER //
// src/components/SearchCatering.vue